






























  import {
    computed, defineComponent, inject, PropType,
  } from '@nuxtjs/composition-api';
  import { SfScrollable, SfHeading } from '@storefront-ui/vue';
  import Checkbox from './Checkbox.vue';
  import type { Aggregation } from '~/modules/GraphQL/types';
import { getClassLabel } from '~/utils/solepro/functions';
  
  export default defineComponent({
    components: {
      Checkbox,
      SfScrollable,
      SfHeading,
    },
    props: {
      filter: {
        type: Object as PropType<Aggregation>,
        required: true,
      },
      hideFilterCodes:{
        type: Array,
        default: () => [],
      }
    },
    setup(props) {
      const { isFilterSelected } = inject('UseFiltersProvider') as any;
      const selected = computed(() => ((id: string, optVal: string) => isFilterSelected(id, optVal)));
      const optionsToShow = computed(()=>props.filter.options.filter(el=>!props.hideFilterCodes.includes(el.value)))
      return { selected, getClassLabel, optionsToShow };
    },
  });
  